'use client'

import { useState, useEffect, useRef } from 'react'

// Format compact number
export function formatCompactNumber(num: number): string {
  if (num >= 1000000) return `${Math.floor(num / 1000000)}M+`
  if (num >= 1000) return `${Math.floor(num / 1000)}k+`
  return num.toString()
}

// Animated counter component
export function AnimatedCounter({ value, prefix = '$', className = '' }: { value: number; prefix?: string; className?: string }) {
  const [displayValue, setDisplayValue] = useState(value)
  const prevValue = useRef(value)
  const [delta, setDelta] = useState<number | null>(null)

  useEffect(() => {
    if (value !== prevValue.current) {
      const diff = value - prevValue.current
      if (diff > 0) {
        setDelta(diff)
        setTimeout(() => setDelta(null), 2000)
      }

      const steps = 10
      const stepValue = diff / steps
      let current = prevValue.current
      let step = 0

      const interval = setInterval(() => {
        step++
        current += stepValue
        setDisplayValue(Math.round(current))
        if (step >= steps) {
          clearInterval(interval)
          setDisplayValue(value)
        }
      }, 30)

      prevValue.current = value
      return () => clearInterval(interval)
    }
  }, [value])

  const formatted = (displayValue / 100).toFixed(0)

  return (
    <span className={`relative ${className}`}>
      {prefix}{formatted}
      {delta !== null && (
        <span className="absolute -right-12 top-0 text-xs text-green-400 animate-fade-in">
          +${(delta / 100).toFixed(0)}
        </span>
      )}
    </span>
  )
}
